import { pipe, UnaryFunction, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WireNode, Wire } from '../../types/wire.types';
import { WiresState } from './state';
import * as actions from './actions';
import { dateComparer } from '../../utils/comparers/primitive';

export const wiresDefaultState: WiresState = {
  dealId: undefined,
  wire: undefined,
  wires: [],
  error: undefined,
  loading: true,
  loadingWire: false,
  loadingAllWires: false
};

export function wiresReducer(
  state = wiresDefaultState,
  action: actions.WiresActions
) {
  const wireId = (action as actions.LoadWireContent).payload;
  switch (action.type) {
    case actions.LOAD_WIRES_LIST:
      if (state.dealId !== action.payload) {
        return {
          ...state,
          wires: [],
          loading: true,
          dealId: action.payload,
          wire: undefined,
          loadingWire: false,
          error: undefined,
        };
      } else {
        return state;
      }
    case actions.LOAD_WIRES_LIST_SUCCESS:
      return {
        ...state,
        wires: (action as actions.LoadWiresListSuccess).payload
          .slice()
          .sort((wire1, wire2) =>
            dateComparer(
              new Date(wire2.receivedDateTimeUtc),
              new Date(wire1.receivedDateTimeUtc)
            )
          ),
        loading: false,
        error: undefined,
      };
    case actions.LOAD_WIRES_LIST_ERROR:
      return {
        ...state,
        wires: [],
        wire: undefined,
        loading: false,
        error: (action as actions.LoadWiresListError).payload,
      };

    case actions.EMPTY_WIRE_CONTENT:
      return {
        ...state,
        wire: undefined,
        loadingWire: false,
      };

    case actions.LOAD_WIRE_CONTENT:
      return {
        ...state,

        wire: undefined,
        error: undefined,
        loadingWire: true,

        wires: state.wires.map((wire) => ({
          ...wire,
          selected: wire.wireId === wireId,
        })),
      };

    case actions.LOAD_WIRE_CONTENT_SUCCESS:
      return {
        ...state,
        wire: (action as actions.LoadWireContentSuccess).payload,
        loadingWire: false,
        error: undefined,
      };
    case actions.LOAD_WIRE_CONTENT_ERROR:
      return {
        ...state,
        wire: undefined,
        loadingWire: false,
        error: (action as actions.LoadWireContentError).payload,
      };

    case actions.INITIATE_PRINT_ALL_WIRES:
      return {
        ...state,
        loadingAllWires: true
      };

    case actions.PRINT_ALL_WIRES:
      return {
        ...state,
        loadingAllWires: false
      };

    default:
      return state;
  }
}

export const selectWires: UnaryFunction<
  Observable<WiresState>,
  Observable<WireNode[]>
> = pipe(map((state: WiresState) => state.wires));

export const selectLoading = pipe(map((state: WiresState) => state.loading));

export const selectWire: UnaryFunction<
  Observable<WiresState>,
  Observable<Wire>
> = pipe(map((state: WiresState) => state.wire));

export const selectLoadingWire = pipe(
  map((state: WiresState) => state.loadingWire)
);

export const selectLoadingAllWires = pipe(
  map((state: WiresState) => state.loadingAllWires)
);